<template>
    <div class="apkManager">

    </div>
</template>

<script>
    export default {
        name: "ApkManager"
    }
</script>

<style scoped>
    .apkManager{
        flex: 1;
        overflow: auto;
        width: 100%;
        border: 0;
    }
</style>
